// src/components/Features.js
import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section className="featuresSection">
      <div className="featuresHeader">
        <h2>Data-driven insights fueling impact and innovation in business education</h2>
        <p>
          Nexed Insight provides pioneering research to the global business education ecosystem, delivering clarity,
          foresight, and intelligence to enhance decision-making and inspire next-gen strategies.
        </p>
      </div>
      <div className="featuresGrid">
        <div className="featureItem">
          <i className="fa-classic fa-brain-circuit featureIcon"></i>
          <h2>Real-time market intelligence</h2>
          <p>
            Empowers business schools and learning providers to listen to the market in real-time—shaping client-centric offerings and continuously updating curricula and engagement strategies.
          </p>
        </div>
        <div className="featureItem">
          <i className="fa-classic fa-chess-knight featureIcon"></i>
          <h2>Smarter learning strategies</h2>
          <p>
            Provides talent leaders and organizations with insight and best practice to optimize their learning and development strategies—making them more measurable, sustainable, and impactful.
          </p>
        </div>
        <div className="featureItem">
          <i className="fa-classic fa-globe featureIcon"></i>
          <h2>Connected learning community</h2>
          <p>
            Identifies gaps between the needs of organizations and the current state of business education, developing practical recommendations to address them.
          </p>
        </div>
        <div className="featureItem">
          <i className="fa-classic fa-infinity featureIcon"></i>
          <h2>Celebrating impact and innovation</h2>
          <p>
            Inspires leaders across the sector by documenting outstanding business education with a focus on innovation and impact.
          </p>
        </div>
        <div className="featureItem">
          <i className="fa-classic fa-handshake featureIcon"></i>
          <h2>Cross-sector collaboration</h2>
          <p>
            Strengthens ties and knowledge-sharing between talent and learning leaders and business education leaders—from CLOs, Heads of Learning, and HR leaders to deans, faculty, EdTech innovators, learning designers, policymakers, and industry experts.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
